import { Block } from 'src/config/api/models/Block';

const getCorrectId = (id: string) => {
  return `block_wrapper-${id}`;
};
export const getBlocksToObserveList = (blocks: Block[] | undefined) => {
  let newBlocks: string[] = [];

  if (!blocks) return newBlocks;
  blocks.map((item: Block) => {
    if (item.type === 'cluster') {
      if (item.sections && item.sections?.length > 0) {
        item.sections.map((sectionItem: Block) => {
          if (sectionItem.childBlocks && sectionItem.childBlocks?.length > 0) {
            sectionItem.childBlocks.map((childItem) => newBlocks.push(getCorrectId(childItem.id)));
          }
          return sectionItem;
        });
      }
    } else {
      newBlocks.push(getCorrectId(item.id));
    }
    return item;
  });
  return newBlocks;
};
